import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useRef } from 'react';
import {
  FormGroup, FormControlLabel, RadioGroup, Radio, FormLabel, Autocomplete,
  Checkbox, Typography, FormControl, MenuItem, InputLabel, Select, IconButton,
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import axiosInstance from '../../../../lib/axios';
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import CustomAutocomplete from '../../../AutoComplete/AutoComplete';
import CloseIcon from '@mui/icons-material/Close';

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "ItmName", label: "Item Name", minWidth: 10 },
  { id: "ItmCode", label: "Code", minWidth: 50 },
  { id: "Make", label: "Brand", minWidth: 50 },
  { id: "UnitName", label: "Unit", minWidth: 50 },
  { id: "CurrRate", label: "Curr Rate", minWidth: 50 },
  { id: "OpRate", label: "Op Rate", minWidth: 50 },
];

const ReipeGrpItem = () => {
  const { register, setValue, reset, watch } = useForm();
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [ItmGrpId, setItmGrpId] = useState(-1);
  const [ItmId, setItmId] = useState(-1);
  const [Mode, setMode] = useState("add");
  const [TransactionData, setTransactionData] = useState([]);
  const [CategoryDrp, setCategoryDrp] = useState([]);
  const [GroupDrp, setGroupDrp] = useState([]);
  const [SubGrpdrp, setSubGrpdrp] = useState([]);
  const [Unitdrp, setUnitdrp] = useState([]);
  const [ItmType, setItmType] = useState("");
  const [OpenDForDelete, setOpenDForDelete] = useState(false);
  const [AllDisUnable, setAllDisUnable] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const contentRef = useRef(null);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const handlePrint = useReactToPrint({ contentRef });
  const [image, setImage] = useState(null);
  const [imgName, setImgName] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      await fetchCategoryData();
      await fetchUnitToData();
      await fetchDashboardData();

      if (location.state) {
        setAllDisUnable(false);
        let ItmId = location.state.ItmId;
        setItmId(location.state.ItmId);
        await fetchTransactionData(ItmId, "R");
      } else {
        setMode("add");
        setAllDisUnable(true);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (TransactionData.length > 0 && Mode !== "add") {
      const obj = watch();
      for (let key in obj) {
        if (TransactionData[0].hasOwnProperty(key)) {
          setValue(key, TransactionData[0][key]);
        } else {
          setValue(key, "");
        }
      }

      const fixImageUrl = (url) => {
        if (!url) return '';
        return url.replace(/^http:\/([^/])/, 'http://$1');
      };

      setImage(fixImageUrl(TransactionData[0].ItmImage));
      setImgName(TransactionData[0].ImgName || '');

      setItmType(TransactionData[0].ItmType);
      setAllDisUnable(false);
      handleCategoryChange({ target: { name: "ItmCatId", value: watch("ItmCatId") } });
      handleGroupChange({ target: { name: "ItemGrpId", value: watch("ItemGrpId") } });
    } else if (Mode === "add") {
      handleAddClick();
    }
  }, [TransactionData, Mode]);

  const fetchDashboardData = async () => {
    try {
      const res = await axiosInstance.post("MstItm/GetMstItmDashBoard", {
        SearchText: "",
      });
      if (res.data && res.data.Data) {
        setRows(res.data.Data);
        setDataForPrint(res.data.Data);
      } else {
        setRows([]);
        setDataForPrint({});
      }
    } catch (err) {
      toast.error("Error fetching dashboard data");
    }
  };

  const fetchCategoryData = async () => {
    try {
      const response = await axiosInstance.post(
        `MstItmCat/GetMstItmCatdrp`, { Flag: 'Food' }
      );
      if (response.data.Status === 0) {
        setCategoryDrp(response.data.Data);
      } else {
        toast.error('Error fetching Category data');
      }
    } catch (error) {
      toast.error('Error fetching Category data');
    }
  };

  const fetchUnitToData = async () => {
    try {
      const response = await axiosInstance.post(`MstUnit/getMstUnitdrp`, {});
      if (response.data.Status === 0) {
        setUnitdrp(response.data.Data);
      } else {
        toast.error('Error fetching Unit data');
      }
    } catch (error) {
      toast.error('Error fetching Unit data');
    }
  };

  const fetchGroupData = async () => {
    try {
      const response = await axiosInstance.post(`MstItmGrp/GetMstItmGrpDashBoard`, {
        start: 4,
        PageSize: 0,
        SearchText: "",
        Flag: "F"
      });
      if (response.data.Status === 0) {
        setGroupDrp(response.data.Data);
      } else {
        toast.error('Error fetching Group data');
      }
    } catch (error) {
      toast.error('Error fetching Group data');
    }
  };

  const fetchTransactionData = async (ItmId, Flag) => {
    try {
      const response = await axiosInstance.post(`MstItm/RetriveMstItm`, {
        "ItmId": ItmId,
        "Flag": Flag
      });
      if (response.data.Status === 0) {
        if (Flag === "D") {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(ItmId, "L");
          return;
        }
        const Data = response.data.Data ?? [];
        setTransactionData(Data);
        setItmId(response.data.Data[0].ItmId);
        setMode("view");
      } else {
        if (Flag !== "D") {
          setItmId(-1);
          Mode === "view" ? setMode("add") : handleAddClick();
        }
        toast.info(response.data.Message);
      }
    } catch (error) {
      toast.error('Error fetching Transaction data:', error);
    }
  };

  const handleAddClick = () => {
    setMode("add");
    setAllDisUnable(true);
    resetFunc();
    setImage('');
    setImgName('');
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        setImgName(file.name);
      };
      reader.readAsDataURL(file);
    }
  };

  const getBase64FromUrl = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const resetFunc = () => {
    reset({
      "ItmCatId": "",
      "ItmGrpId": "",
      "ItmSubGrpId": "",
      "ItmCode": "",
      "Make": "",
      "ItmName": " ",
      "SizeCapacity": "",
      "ItmDetail": "",
      "ItmShortname": "",
      "ItmSpec": "",
      "UnitId": "",
      "ToUnitId": "",
      "ConvFactor": "1",
      "OEMPartNo": "",
      "ItmImage": "",
      "ImgName": "",
      "OpRate": "0.00",
      "CurrRate": "0.00",
      "HsncodeKey": "",
      "Status": "1",
      "Remark": "",
      "ItmType": "",
    });
    DefaultValues(CategoryDrp, GroupDrp, SubGrpdrp, Unitdrp, setValue);
  };

  const DefaultValues = async (CategoryDrp, GroupDrp, SubGrpdrp, Unitdrp, setValue) => {
    if (CategoryDrp.length > 0) {
      await setValue('ItmCatId', CategoryDrp[0].ItmCatId);
    }
    if (GroupDrp.length > 0) {
      await setValue('ItmGrpId', GroupDrp[0].ItmGrpId);
    }
    if (SubGrpdrp.length > 0) {
      await setValue('ItmSubGrpId', SubGrpdrp[0].ItmSubGrpId);
    }
    if (Unitdrp.length > 0) {
      await setValue('UnitId', Unitdrp[0].UnitId);
    }
    if (Unitdrp.length > 0) {
      await setValue('ToUnitId', Unitdrp[0].UnitId);
    }
  };

  const handleSubmitClick = async () => {
    const Obj = watch();
    if (
      !watch("ItmCatId") ||
      !watch("ItmGrpId") ||
      // !watch("ItmCode") ||
      !watch("ItmName") ||
      !watch("ToUnitId") ||
      !watch("UnitId")
    ) {
      toast.info("Please fill in all required fields!");
      return;
    }

    const DEFAULT_IMAGE_URL = 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg';
    const DEFAULT_IMAGE_NAME = 'no-image-available.svg';

    const finalImage = image || await getBase64FromUrl(DEFAULT_IMAGE_URL);
    const finalImgName = imgName || DEFAULT_IMAGE_NAME;

    let Payload = {
      "ItmCatId": watch("ItmCatId") || 1,
      "ItmGrpId": watch("ItmGrpId") || 1,
      "ItmSubGrpId": watch("ItmSubGrpId") || 1,
      "ItmCode": watch("ItmCode"),
      "Make": watch("Make"),
      "ItmName": watch("ItmName"),
      "SizeCapacity": watch("SizeCapacity"),
      "ItmDetail": watch("ItmDetail"),
      "ItmShortname": watch("ItmShortname"),
      "ItmSpec": "Spec details for Item Two",
      "UnitId": watch("UnitId") || 1,
      "ToUnitId": watch("ToUnitId") || 1,
      "ConvFactor": watch("ConvFactor"),
      "OEMPartNo": watch("OEMPartNo"),
      "ItmImage": finalImage,
      "ImgName": finalImgName,
      "OpRate": watch("OpRate"),
      "CurrRate": watch("CurrRate"),
      "HsncodeKey": "1234",
      "Status": watch("Status"),
      "Remark": watch("Remark"),
      "ItmType": ItmType,
      "CreatedBy": 1
    };

    if (Mode === "add") {
      try {
        const response = await axiosInstance.post(`MstItm/InsertMstItm`, Payload);
        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(1, "L");
          setMode("view");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error('Error inserting data:', error);
      }
    } else {
      Payload = { ...Payload, ItmId, UpdatedBy: parseInt(UserId) };
      delete Payload.CreatedBy;

      try {
        const response = await axiosInstance.post(`MstItm/UpdateMstItm`, Payload);
        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          await UnLock(ItmId, "MstItm", "ItmId");
          fetchTransactionData(ItmId, "R");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error('Error updating data:', error);
      }
    }
  };

  const handleDeleteClick = () => {
    setOpenDForDelete(true);
  };

  const handleConfirmDelete = () => {
    fetchTransactionData(ItmId, "D");
    setOpenDForDelete(false);
  };

  const handleCancelClick = async () => {
    if (ItmId === -1 && Mode === "add") {
      await fetchTransactionData(1, "L");
      setMode("add");
      setAllDisUnable(true);
    } else if (ItmId !== -1) {
      await UnLock(ItmId, "MstItm", "ItmId");
      await fetchTransactionData(ItmId, "R");
      setMode("view");
      setAllDisUnable(false);
    }
  };

  const handleCategoryChange = async (e) => {
    setValue(e.target.name, e.target.value);
    let obj = CategoryDrp.find(obj => obj.ItmCatId == e.target.value);
    setItmType(obj.ItmType);

    try {
      const response = await axiosInstance.post(`MstItmGrp/GetMstItmGrpdrp`, {
        "ItmCatId": e.target.value,
        "Flag": ""
      });
      if (response.data.Status === 0) {
        setGroupDrp(response.data.Data);
      } else {
        toast.error('Error fetching Group data');
      }
    } catch (error) {
      toast.error('Error fetching Group data');
    }
  };

  const handleCheckBoxChange = () => {
    setValue("Status", watch("Status") === "1" ? "0" : "1");
  };

  const handleClickBackToTable = () => {
    navigate('/recipeitem-table');
  };

  const handlePrevClick = () => {
    fetchTransactionData(ItmId, "P");
  };

  const handleNextClick = () => {
    fetchTransactionData(ItmId, "N");
  };

  const handleCancelDButton = () => {
    setOpenDForDelete(false);
  };

  const handleConfirmDDelete = () => {
    fetchTransactionData(ItmId, "D");
    setOpenDForDelete(false);
  };

  const handleEditClick = async () => {
    let Flag = await checkAndLock(ItmId, "MstItm", "ItmId");
    switch (Flag) {
      case 0:
        setMode("view");
        setAllDisUnable(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  // Handle Group Change
  const handleGroupChange = async (e) => {
    setValue(e.target.name, e.target.value);
    try {
      const response = await axiosInstance.post(`MstItmSubGrp/GetMstItmSubGrpdrp`,
        {
          "ItmGrpId": e.target.value,
          "Flag": ""
        }
      );
      if (response.data.Status === 0) {
        setSubGrpdrp(response.data.Data);
      } else {
        toast.error('Error fetching Group data');
      }
    } catch (error) {
      toast.error('Error fetching Group data');
    }
  };

  // Handle Sub Group Change
  const handleSubGrpChange = async (e) => {
    setValue(e.target.name, e.target.value);
  };

  // Handle Unit Change
  const handleUnitChange = async (e) => {
    setValue(e.target.name, e.target.value);
    // If Unit From (UnitId) is changed, set the same value for Unit To (ToUnitId)
    if (e.target.name === "UnitId") {
      setValue("ToUnitId", e.target.value);
    }
  };

  return (
    <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
      <Dialog open={OpenDForDelete} onClose={handleCancelDButton}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Do You Want To Delete This Item ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button size='small'
            sx={{
              backgroundColor: '#ce3535',
              color: 'white',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#ce3535',
                color: 'white'
              }
            }}
            onClick={handleConfirmDDelete}
          >
            Delete
          </Button>
          <Button size='small'
            sx={{
              backgroundColor: '#4a9221',
              color: 'white',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#4a9221',
                color: 'white'
              }
            }}
            onClick={handleCancelDButton}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
      <Grid container spacing={2} className='form_grid'>
        <Grid item xs={12} className='form_title'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: '20px',
            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
          }}
        >
          <Grid
            sx={{
              display: 'flex',
              justifyContent: { xs: 'center', sm: 'flex-start' },
              marginBottom: { xs: '10px', sm: 0 }
            }}
          >
            <Button
              variant="contained"
              size="small"
              className='three-d-button-previous'
              sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
              onClick={handlePrevClick}
              disabled={AllDisUnable}
            >
              <KeyboardArrowLeftIcon />
            </Button>

            <Button
              variant="contained"
              size="small"
              className='three-d-button-next'
              sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
              onClick={handleNextClick}
              disabled={AllDisUnable}
            >
              <NavigateNextIcon />
            </Button>
          </Grid>

          <Typography
            variant="h5"
            sx={{
              margin: 'Auto',
              textAlign: { xs: 'center', sm: 'center' },
              fontSize: { xs: '24px', sm: '18px', md: '24px' }
            }}
          >
            Recipe Ingredients Master
          </Typography>

          <Grid sx={{ display: "flex", justifyContent: "end" }}>
            <CrudButtons
              moduleName={"Recipe Ingredients Master"}
              mode={Mode}
              onAdd={handleAddClick}
              onEdit={handleEditClick}
              onView={handlePrint}
              onDelete={handleDeleteClick}
              onExit={handleClickBackToTable}
              readOnlyMode={!AllDisUnable}
              onPrevious={handlePrevClick}
              onNext={handleNextClick}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} className='form_field' sx={{ marginX: "auto" }}>
          <Grid container spacing={0.5}>
            <Grid item xs={12} sm={4}>
              <FormControl variant="filled" fullWidth className="custom-select">
                <InputLabel id="companyName-select-label">
                  <span>
                    Category List <span style={{ color: "red" }}>*</span>
                  </span>
                </InputLabel>
                <Select
                  labelId="companyName-select-label"
                  id="ItmCatId"
                  name="ItmCatId"
                  value={watch('ItmCatId') || ''}
                  className="custom-textfield"
                  {...register('ItmCatId')}
                  onChange={handleCategoryChange}
                  disabled={!AllDisUnable}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        overflow: "auto",
                      },
                    },
                  }}
                  sx={{
                    backgroundColor: '#ffffff',
                    '&.Mui-disabled': {
                      backgroundColor: '#ffffff',
                    },
                  }}
                >
                  {CategoryDrp.length > 0 && CategoryDrp?.map((type) => (
                    <MenuItem key={type.ItmCatId} value={type.ItmCatId}>
                      {type.ItmCatName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Group */}
            <Grid item xs={12} sm={4}>
              <FormControl variant="filled" fullWidth className="custom-select">
                <InputLabel id="companyName-select-label">
                  <span>
                    Group List    <span style={{ color: "red" }}>*</span>
                  </span>
                </InputLabel>
                <Select
                  labelId="companyName-select-label"
                  id="ItmGrpId"
                  name="ItmGrpId"
                  value={watch('ItmGrpId') || ''}
                  className="custom-textfield"
                  {...register('ItmGrpId')}
                  onChange={handleGroupChange}
                  disabled={!AllDisUnable}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        overflow: "auto",
                      },
                    },
                  }}
                  sx={{
                    backgroundColor: '#ffffff',
                    '&.Mui-disabled': {
                      backgroundColor: '#ffffff',
                    },
                  }}
                >
                  {GroupDrp.length > 0 && GroupDrp?.map((type) => (
                    <MenuItem key={type.ItmGrpId} value={type.ItmGrpId}>
                      {type.ItmGrpName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Subgroup */}
            <Grid item xs={12} sm={4}>
              <FormControl variant="filled" fullWidth className="custom-select">
                <InputLabel id="companyName-select-label">
                  <span>
                    SubGroup  List    <span style={{ color: "red" }}>*</span>
                  </span>
                </InputLabel>
                <Select
                  labelId="companyName-select-label"
                  id="ItmSubGrpId"
                  name="ItmSubGrpId"
                  value={watch('ItmSubGrpId') || ''}
                  className="custom-textfield"
                  {...register('ItmSubGrpId')}
                  onChange={handleSubGrpChange}
                  disabled={!AllDisUnable}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        overflow: "auto",
                      },
                    },
                  }}
                  sx={{
                    backgroundColor: '#ffffff',
                    '&.Mui-disabled': {
                      backgroundColor: '#ffffff',
                    },
                  }}
                >
                  {SubGrpdrp.length > 0 && SubGrpdrp?.map((type) => (
                    <MenuItem key={type.ItmSubGrpId} value={type.ItmSubGrpId}>
                      {type.ItmSubGrpName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Code */}
            <Grid item xs={12} sm={4}>
              <TextField
                id="ItmCode"
                name="ItmCode"
                label={<span>Code</span>}
                value={watch('ItmCode') || ''}
                {...register("ItmCode")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>

            {/* Name */}
            <Grid item xs={12} sm={4}>
              <TextField
                id="ItmName"
                name="ItmName"
                label={<span>Name <span style={{ color: 'red' }}>*</span></span>}
                value={watch('ItmName') || ''}
                {...register("ItmName")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>

            {/* Brand */}
            <Grid item xs={12} sm={4}>
              <TextField
                id="Make"
                name="Make"
                label={<span>Brand</span>}
                value={watch('Make') || ''}
                {...register("Make")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>

            {/* Capacity */}
            <Grid item xs={12} sm={8}>
              <Grid container spacing={1}>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="SizeCapacity"
                    name="SizeCapacity"
                    label={<span>Capacity</span>}
                    value={watch('SizeCapacity') || ''}
                    {...register("SizeCapacity")}
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    disabled={!AllDisUnable}
                  />
                </Grid>

                {/* Abrv or shortname */}
                <Grid item xs={6} md={6}>
                  <TextField
                    id="ItmShortname"
                    name="ItmShortname"
                    label={<span>Abrv</span>}
                    value={watch('ItmShortname') || ''}
                    {...register("ItmShortname")}
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    disabled={!AllDisUnable}
                  />
                </Grid>

                {/* Unit to */}
                <Grid item xs={6} md={3}>
                  <FormControl variant="filled" fullWidth className="custom-select">
                    <InputLabel id="unit-to-select-label">
                      <span>Unit To <span style={{ color: "red" }}>*</span></span>
                    </InputLabel>
                    <Select
                      labelId="unit-to-select-label"
                      id="UnitId"
                      name="UnitId"
                      value={watch('UnitId') || ''}
                      className="custom-textfield"
                      {...register('UnitId')}
                      onChange={handleUnitChange}
                      disabled={!AllDisUnable}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            overflow: "auto",
                          },
                        },
                      }}
                      sx={{
                        backgroundColor: '#ffffff',
                        '&.Mui-disabled': {
                          backgroundColor: '#ffffff',
                        },
                      }}
                    >
                      {Unitdrp.length > 0 && Unitdrp?.map((type) => (
                        <MenuItem key={type.UnitId} value={type.UnitId}>
                          {type.UnitName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Unit From */}
                <Grid item xs={6} md={3}>
                  <FormControl variant="filled" fullWidth className="custom-select">
                    <InputLabel id="unit-from-select-label">
                      <span>Unit From <span style={{ color: "red" }}>*</span></span>
                    </InputLabel>
                    <Select
                      labelId="unit-from-select-label"
                      id="ToUnitId"
                      name="ToUnitId"
                      value={watch('ToUnitId') || ''}
                      className="custom-textfield"
                      {...register('ToUnitId')}
                      onChange={handleUnitChange}
                      disabled={!AllDisUnable}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            overflow: "auto",
                          },
                        },
                      }}
                      sx={{
                        backgroundColor: '#ffffff',
                        '&.Mui-disabled': {
                          backgroundColor: '#ffffff',
                        },
                      }}
                    >
                      {Unitdrp.length > 0 && Unitdrp?.map((type) => (
                        <MenuItem key={type.UnitId} value={type.UnitId}>
                          {type.UnitName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Rate */}
                <Grid item xs={6} md={3}>
                  <TextField
                    id="CurrRate"
                    name="CurrRate"
                    label={<span>Curr Rate</span>}
                    value={watch('CurrRate') !== undefined ? watch('CurrRate') : '0.00'}
                    {...register("CurrRate")}
                    onChange={(e) => setValue("CurrRate", e.target.value)}
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    disabled={!AllDisUnable}
                  />
                </Grid>

                {/* Op Rate */}
                <Grid item xs={6} md={3}>
                  <TextField
                    id="OpRate"
                    name="OpRate"
                    label={<span>Op Rate</span>}
                    value={watch('OpRate') || ''}
                    {...register("OpRate")}
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    disabled={!AllDisUnable}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <Box
                  sx={{
                    width: 100,
                    height: 100,
                    border: '1px dashed #000',
                    borderRadius: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    position: 'relative',
                    mx: 'auto',
                  }}
                  onClick={() => document.getElementById('item-image').click()}
                >
                  {image ? (
                    <img
                      src={image}
                      alt="Item"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg"
                      alt="Default"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  )}

                  {image && (
                    <IconButton
                      size="small"
                      sx={{
                        position: 'absolute',
                        top: 1,
                        right: 1,
                        width: 20,
                        height: 20,
                        padding: 0,
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setImage('');
                        setImgName('');
                      }}
                      disabled={!AllDisUnable}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  )}
                </Box>

                <input
                  type="file"
                  id="item-image"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleImageUpload}
                  disabled={!AllDisUnable}
                />
              </FormControl>
            </Grid>

            {/* Conversion Factor */}
            <Grid item xs={12} sm={2}>
              <TextField
                id="ConvFactor"
                name="ConvFactor"
                label={<span>Conversion Factor</span>}
                value={watch('ConvFactor') || ''}
                {...register("ConvFactor")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>

            {/* OEM Port */}
            <Grid item xs={12} sm={2}>
              <TextField
                id="OEMPartNo"
                name="OEMPartNo"
                label={<span>Options</span>}
                value={watch('OEMPartNo') || ''}
                {...register("OEMPartNo")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>

            {/* Remark */}
            <Grid item xs={12} sm={6}>
              <TextField
                id="Remark"
                name="Remark"
                label={<span>Remark</span>}
                value={watch('Remark') || ''}
                {...register("Remark")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>

            {/* Item Type */}
            {/* <Grid item xs={12} md={4}>
              <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                <Grid item>
                  <FormLabel component="legend" sx={{ fontWeight: 'bold' }}>Item Type</FormLabel>
                </Grid>
                <Grid item>
                  <FormControl component="fieldset">
                    <RadioGroup row name='ItmType' value={ItmType} {...register('ItmType')}>
                      <FormControlLabel
                        value="A"
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} disabled />}
                        label="Asset"
                        className="custom-textfield"
                      />
                      <FormControlLabel
                        value="C"
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} disabled />}
                        label="Consumable"
                        className="custom-textfield"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid> */}

            {/* Status Checkbox */}
            <Grid item xs={12} md={2}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!AllDisUnable}
                      name="Status"
                      checked={watch("Status") === "1"}
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Status"
                />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                id="ItmDetail"
                name="ItmDetail"
                label={<span>Description</span>}
                value={watch('ItmDetail') || ''}
                {...register("ItmDetail")}
                variant="filled"
                fullWidth
                multiline
                rows={1.5}
                size="small"
                className="custom-textfield"
                disabled={!AllDisUnable}
                sx={{
                  '& .MuiFilledInput-root': {
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: 'white',
                    },
                    '&.Mui-disabled': {
                      backgroundColor: '#f0f0f0',
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className="form_button">
          <Button
            variant="contained"
            sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
            onClick={handleSubmitClick}
            disabled={!AllDisUnable}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
            onClick={handleCancelClick}
            disabled={!AllDisUnable}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>

      {/* Hidden Print Section */}
      <div style={{ display: "none" }}>
        {Object.keys(DataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Recipe Ingredients Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
    </Box>
  );
};

export default ReipeGrpItem;